import { useContext } from "react";
import { ThemeContext } from "../../../theme/ThemeContext";


const IncidentCard = ({ incident, clickHandler, isActive, no, status }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  const isCompleted = status === 2;

  const mode = isDark ? "dark" : "light";
  const activeClass = isActive ? "active" : "inactive";

  const circleClass = `circle ${isCompleted ? "completed" : `${mode} ${activeClass}`}`;

  const cardClass = isActive ? "active-card" : "";

  return (
    <div
      onClick={() => clickHandler?.(incident)}
      className={`card shadow-sm border-0 rounded-3 p-3 mb-4 ${cardClass}`}
      style={{
        cursor: "pointer",
        minHeight: "100px",
        height: "100%",
      }}
    >
      <div className="d-flex flex-column justify-content-center h-100">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
          <h6 className="mb-0 text-color">
            Incident {no}
          </h6>
          <div className={circleClass + " mb-1"} />
        </div>
        <h6 className="mb-0 mt-2 lh-base text-color">
          {incident.incidentTitle}
        </h6>
      </div>
    </div>
  );
};

export default IncidentCard;
